export default "__VITE_ASSET__e3a2997c__"